import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { KeyValue } from '@common/models/key-value.model';
import { CAREER_CONFIG_TYPES,
         DATA_PER_PAGE,
         CANCEL
        } from '@root/app.constant';
import { NgForm } from '@angular/forms';
import { CatalogService } from '../catalog.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { CommonDataService } from '@root/shared/catalogue/services/common-data.service';

@Component({
  selector: 'app-catalogue-career-config',
  templateUrl: './catalogue-career-config.component.html',
  styleUrls: ['./catalogue-career-config.component.scss']
})
export class CatalogueCareerConfigComponent implements OnInit {

  @ViewChild('f', { static: false }) form: NgForm;

  availableConfigTypes: KeyValue[] = CAREER_CONFIG_TYPES;

  selectedConfigType: string = 'LOCATION';

  enteredLocation: string;

  enteredDepartment: String;

  data = [];

  pageSize: number = DATA_PER_PAGE;

  editFeature: boolean = false;
  dataSelected: any;

  constructor(private catalogService: CatalogService, private toastr: ToastrService, private errorHandler: ErrorHandler,
    private commonDataService:CommonDataService) { }

  ngOnInit() {
    this.getLocationList();
  }

  radioChange(event) {
    if (event.value === "DEPARTMENT") {
      this.getDepartmentList();
    } else if (event.value === "LOCATION") {
      this.getLocationList();
    }
  }

  getLocationList = () => {
    this.catalogService.getCareersLocation().subscribe((response) => {
      if (response.status === 0) {
        this.data = response.data.locations;
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  getDepartmentList = () => {
    this.catalogService.getCareersDeparment().subscribe((response) => {
      if (response.status === 0) {
        this.data = response.data.departments;
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  resetForm = () => {
    this.enteredLocation = "";
    this.enteredDepartment = "";
  }

  addLocation = () => {
    const object = {
      "location": this.enteredLocation
    }
    this.catalogService.addCareerLocation(object).subscribe((response) => {
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.resetForm();
        this.getLocationList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    }, (error) => {
      this.errorHandler.handleError(error);
    })
  }

  addDepartment = () => {
    const object = {
      "department": this.enteredDepartment
    }
    this.catalogService.addCareerDepartment(object).subscribe((response) => {
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.resetForm();
        this.getDepartmentList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  editLocation = () => {
    const object = {
      "id": this.dataSelected.id,
      "location": this.enteredLocation
    }
    this.catalogService.updateCareerLocation(object).subscribe((response) => {
      this.resetForm();
      this.editFeature = false;
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.getLocationList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    }, (error) => {
      this.errorHandler.handleError(error);
    })
  }

  editDepartment = () => {
    const object = {
      "id": this.dataSelected.id,
      "department": this.enteredDepartment
    }
    this.catalogService.updateCareerDepartment(object).subscribe((response) => {
      this.resetForm();
      this.editFeature = false;
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.resetForm();
        this.getDepartmentList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  proceesData = () => {
    if (this.editFeature) {
      switch (this.selectedConfigType) {
        case 'LOCATION':
          this.editLocation();
          break;
        case 'DEPARTMENT':
          this.editDepartment()
          break;
      }
    } else {
      switch (this.selectedConfigType) {
        case 'LOCATION':
          this.addLocation();
          break;
        case 'DEPARTMENT':
          this.addDepartment()
          break;
      }
    }
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  editConfig = (data) => {
    this.editFeature = true;
    this.dataSelected=data;
    this.scrollTop();
    switch (this.selectedConfigType) {
      case 'LOCATION':
        this.enteredLocation = data.value;
        break;
      case 'DEPARTMENT':
        this.enteredDepartment = data.value;
        break;
    }
  }

  deleteLocation = (data) => {
    const object = {
      "id":data.id
    }
    this.catalogService.deleteCareerLocation(object).subscribe((response) => {
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.getLocationList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    }, (error) => {
      this.errorHandler.handleError(error);
    })
  }

  deleteDepartment = (data) => {
    const object = {
      "id":data.id
    }
    this.catalogService.deleteCareerDepartment(object).subscribe((response) => {
      if (response.status === 0) {
        this.toastr.success(response.message);
        this.getDepartmentList();
      }
      else {
        this.errorHandler.handleError(response);
      }
    }, (error) => {
      this.errorHandler.handleError(error);
    })
  }

  deleteData = (data) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          switch (this.selectedConfigType) {
            case 'LOCATION':
              this.deleteLocation(data);
              break;
            case 'DEPARTMENT':
              this.deleteDepartment(data);
              break;
          }
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };
}

